<template>
  <div v-if="dateValue"
       class="integration-created-date-table-cell">
    {{ formattedDate }}
  </div>
</template>

<script>
import moment from 'moment';

const DATE_FORMAT = 'DD MMM YYYY';

export default {
  name: 'IntegrationCreatedDateTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    dateValue() {
      return this.item[this.column.name];
    },
    formattedDate() {
      return moment(this.dateValue).format(DATE_FORMAT);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/design-system";

.integration-created-date-table-cell {
  font-family: $font-family-regular;
  font-size: rem(14);
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--text-primary);
}

</style>
